/* oc-lp: behaviour for the referans landing clones. Loaded with defer, safe to include more than once. */
(function () {
  if (window.__ocLpInit) return;
  window.__ocLpInit = true;

  function productArea() {
    return document.querySelector('.product__info-container') || document.querySelector('product-info');
  }

  function scrollToProduct() {
    var t = productArea();
    if (!t) return;
    var header = document.querySelector('.section-header, sticky-header, header.header');
    var off = header ? header.getBoundingClientRect().height + 12 : 16;
    var y = t.getBoundingClientRect().top + window.pageYOffset - off;
    window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
  }

  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('[data-oclp-scroll]') : null;
    if (!b) return;
    e.preventDefault();
    scrollToProduct();
  });

  // sticky bar: visible after the first viewport, hidden while the buy box is on screen
  function initBar() {
    var bar = document.querySelector('[data-oclp-bar]');
    if (!bar) return;
    var ticking = false;
    function update() {
      ticking = false;
      var vh = window.innerHeight;
      var t = productArea();
      var inBuy = false;
      if (t) {
        var r = t.getBoundingClientRect();
        var vis = Math.max(0, Math.min(r.bottom, vh) - Math.max(r.top, 0));
        inBuy = vis > 0 && vis / Math.max(r.height, 1) >= 0.1;
      }
      bar.classList.toggle('is-active', window.scrollY > vh && !inBuy);
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  // testimonials: fade slider with dots, auto-rotates
  function initTesti(root) {
    var items = root.querySelectorAll('.oclp-testi__item');
    var dots = root.querySelectorAll('.oclp-testi__dot');
    if (items.length < 2) return;
    var i = 0;
    var timer;
    function go(n) {
      i = (n + items.length) % items.length;
      items.forEach(function (el, k) { el.classList.toggle('is-active', k === i); el.setAttribute('aria-hidden', k === i ? 'false' : 'true'); });
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); d.setAttribute('aria-current', k === i ? 'true' : 'false'); });
    }
    function start() { clearInterval(timer); timer = setInterval(function () { go(i + 1); }, 6000); }
    dots.forEach(function (d, k) { d.addEventListener('click', function () { go(k); start(); }); });
    go(0);
    start();
  }

  // counters: count up once when visible
  function initCount(root) {
    var nums = root.querySelectorAll('[data-oclp-count]');
    function run(el) {
      var to = parseFloat(el.getAttribute('data-oclp-count')) || 0;
      var dur = 1200, t0 = Date.now();
      var iv = setInterval(function () {
        var p = Math.min(1, (Date.now() - t0) / dur);
        el.textContent = Math.round(to * (1 - Math.pow(1 - p, 3)));
        if (p >= 1) { clearInterval(iv); el.textContent = to; }
      }, 30);
    }
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { run(en.target); io.unobserve(en.target); } });
    }, { threshold: 0.4 });
    nums.forEach(function (n) { io.observe(n); });
  }

  // material compare slider
  function initCmp(root) {
    var input = root.querySelector('input[type=range]');
    if (!input) return;
    function set() { root.style.setProperty('--pos', input.value + '%'); }
    input.addEventListener('input', set);
    set();
  }

  function init() {
    initBar();
    document.querySelectorAll('.oclp-testi').forEach(initTesti);
    document.querySelectorAll('.oclp-count').forEach(initCount);
    document.querySelectorAll('.oclp-cmp').forEach(initCmp);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function () { window.__ocLpInit = true; init(); });
})();
